import { Divider, Stack } from '@mui/material';
import { useParams } from 'react-router';
import {
  useMatchday, useUpdateGame, useUpdateMatchday,
} from '../../store/Matchday';
import TeamCard from './TeamCard';
import GameCard from './GameCard';
import ScoreCard from './ScoreCard';
import DateCard from './DateCard';
import LeagueCard from './LeagueCard';
import { Team } from '../../lib/Team';
import { League } from '../../lib/Matchday';

export default function Matchday() {
  const { id } = useParams();
  const [matchday] = useMatchday(id);
  const updateMatchday = useUpdateMatchday();
  const updateGame = useUpdateGame();

  const onDateChange = async (newValue: Date) => {
    if (!matchday) return;
    const newMatchday = { ...matchday, date: newValue };
    await updateMatchday(newMatchday);
  };

  const onNameHomeChange = async (newValue: Team) => {
    if (!matchday) return;
    const newMatchday = { ...matchday, teams: { ...matchday.teams, home: newValue } };
    await updateMatchday(newMatchday);
  };

  const onNameGuestChange = async (newValue: Team) => {
    if (!matchday) return;
    const newMatchday = { ...matchday, teams: { ...matchday.teams, guest: newValue } };
    await updateMatchday(newMatchday);
  };

  if (!matchday) { return <p>Lade Spieltag ...</p>; }

  let matches;
  if (matchday.league === League.REGIONALLIGA) {
    matches = (
      <>
        <Divider sx={{ color: 'text.secondary' }}>1. Runde</Divider>
        {[matchday.games.slice(0, 4).map((game) => (
          <GameCard key={game.id} game={game} onEdit={updateGame} />
        ))]}
        <Divider sx={{ color: 'text.secondary' }}>2. Runde</Divider>
        {[matchday.games.slice(4, 9).map((game) => (
          <GameCard key={game.id} game={game} onEdit={updateGame} />
        ))]}
      </>
    );
  } else if ([League.OBERLIGA, League.VERBANDSLIGA, League.LANDESLIGA].includes(matchday.league)) {
    matches = (
      <>
        <Divider sx={{ color: 'text.secondary' }}>1. Runde</Divider>
        {[matchday.games.slice(0, 4).map((game) => (
          <GameCard key={game.id} game={game} onEdit={updateGame} />
        ))]}
        <Divider sx={{ color: 'text.secondary' }}>2. Runde</Divider>
        {[matchday.games.slice(4, 6).map((game) => (
          <GameCard key={game.id} game={game} onEdit={updateGame} />
        ))]}
        <Divider sx={{ color: 'text.secondary' }}>3. Runde</Divider>
        {[matchday.games.slice(6, 10).map((game) => (
          <GameCard key={game.id} game={game} onEdit={updateGame} />
        ))]}
      </>
    );
  } else {
    matches = (
      <>
        <Divider sx={{ color: 'text.secondary' }}>Spiele</Divider>
        {[matchday.games.map((game) => (
          <GameCard key={game.id} game={game} onEdit={updateGame} />
        ))]}
      </>
    );
  }

  return (
    <Stack spacing={2}>
      <Divider sx={{ color: 'text.secondary' }}>Allgemein</Divider>
      <LeagueCard label="Liga" value={matchday.league} />
      <DateCard label="Datum" value={matchday.date} onChange={onDateChange} />
      <TeamCard label="Heimmannschaft" value={matchday.teams.home} onChange={onNameHomeChange} />
      <TeamCard label="Gastmannschaft" value={matchday.teams.guest} onChange={onNameGuestChange} />
      {matches}
      <Divider sx={{ color: 'text.secondary' }}>Spielstand</Divider>
      <ScoreCard matchday={matchday} />
    </Stack>
  );
}
